import React from 'react';
import { Badge } from 'react-bootstrap';

/**
 * Red "Healthcare (HIPAA)" pill shown wherever a healthcare-tagged data source's inventory is
 * edited. Tooltip carries the determination provenance (healthcareTagSource, e.g.
 * "COMMERCIAL_MATCH,ENTITY_FINDINGS" from the worker's healthcare_determination signals).
 * Renders nothing unless healthcareTag is exactly true.
 */
export default function HealthcareBadge({ healthcareTag = false, healthcareTagSource = '' }) {
  if (healthcareTag !== true) return null;
  const title = healthcareTagSource
    ? `Auto-detected: ${String(healthcareTagSource).split(',').map((s) => s.trim()).filter(Boolean).join(', ')}`
    : 'Auto-detected healthcare data source';
  return (
    <Badge
      pill
      variant='danger'
      style={{ fontSize: '0.8rem', padding: '6px 12px' }}
      title={title}
      data-testid='healthcare-badge'
    >
      Healthcare (HIPAA)
    </Badge>
  );
}
